import { render, staticRenderFns } from "./shopNamingRules.vue?vue&type=template&id=606dce4a&scoped=true&"
import script from "./shopNamingRules.vue?vue&type=script&lang=js&"
export * from "./shopNamingRules.vue?vue&type=script&lang=js&"
import style0 from "./shopNamingRules.vue?vue&type=style&index=0&id=606dce4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606dce4a",
  null
  
)

export default component.exports